"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebContractGetAuthSessionResponseSchema = exports.WebContractLoginResponseSchema = exports.WebContractRegisterResponseSchema = exports.WebContractForgotPasswordRequestSchema = exports.WebContractRegisterRequestSchema = void 0;
const zod_1 = require("zod");
const schema_builder_1 = require("../../../shared/schema-builder");
const RoleSchema = zod_1.z.enum(['ADMIN', 'STAFF', 'USER']);
const UserSchema = zod_1.z.object({
    role: RoleSchema,
    id: zod_1.z.string().uuid(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    deletedAt: zod_1.z.coerce.date().nullable(),
    email: zod_1.z.string(),
    name: zod_1.z.string(),
    dateOfBirth: zod_1.z.coerce.date().nullable(),
    phoneNumber: zod_1.z.string(),
});
exports.WebContractRegisterRequestSchema = UserSchema.pick({
    email: true,
    name: true,
    dateOfBirth: true,
    phoneNumber: true,
}).extend({ password: zod_1.z.string() });
exports.WebContractForgotPasswordRequestSchema = zod_1.z.object({ email: zod_1.z.string() });
const WebContractAuthSchema = new schema_builder_1.SchemaBuilder(UserSchema.pick({
    email: true,
    name: true,
    createdAt: true,
    dateOfBirth: true,
    phoneNumber: true,
}))
    .replaceDateField('dateOfBirth', zod_1.z.string().date().nullable())
    .replaceDateField('createdAt')
    .build();
exports.WebContractRegisterResponseSchema = zod_1.z.object({ session: WebContractAuthSchema });
exports.WebContractLoginResponseSchema = zod_1.z.object({ session: WebContractAuthSchema });
exports.WebContractGetAuthSessionResponseSchema = zod_1.z.object({ session: WebContractAuthSchema });
